import {
  ANALYTICS_ID_ATTR,
  ANALYTICS_PREFIX,
} from '../config/analyticsAttributes'

export function collectExtraProperties(
  element: HTMLElement,
): Record<string, string> {
  const extra: Record<string, string> = {}
  for (const attr of element.attributes) {
    if (
      attr.name.startsWith(ANALYTICS_PREFIX) &&
      attr.name !== ANALYTICS_ID_ATTR
    ) {
      const key = attr.name.slice(ANALYTICS_PREFIX.length)
      extra[key] = attr.value
    }
  }
  return extra
}
